import React from "react";
import { Button } from "@mui/material";
export default function SchedulingPageControls({ query, label = "results" }) {
  return <div className="schedule-page-controls" aria-label={`${label} pages`}>
    <span aria-live="polite">{query.isError ? "Results unavailable" : query.isLoading ? "Loading…" : `Page ${query.page+1} · ${query.data.length} ${label}`}</span>
    <Button disabled={query.isFetching} onClick={() => query.refetch()}>{query.isFetching && !query.isLoading ? "Refreshing…" : "Refresh"}</Button>
    <Button disabled={!query.hasPrevious || query.isFetching} onClick={query.previous}>Previous</Button>
    <Button disabled={!query.hasNext || query.isFetching} onClick={query.next}>Next</Button>
  </div>;
}
